/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { Box, Typography, TypographyProps } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

export type TextFieldInputProps = {
  emptyLabelText?: string;
  label?: string;
  value?: string;
  fullWidth?: boolean;

  renderValue?: (props: ReactNode | string) => string;
  renderLabel?: (props: ReactNode | string) => string;
  boxProps?: Record<string, unknown>;
  overrides?: string;
} & TypographyProps;

export default function TextFieldSkeleton({
  label,
  value,
  fullWidth = true,
  renderValue = (value) => value as string,
  renderLabel = (label) => label as string,
  emptyLabelText = 'Lorem ipsum dolar',
  overrides = '',
}: TextFieldInputProps): JSX.Element {
  const labelText = label ? label : emptyLabelText;
  const primaryValue = renderLabel(labelText);
  const valueText = value ? value : primaryValue;
  const secondaryValue = renderValue(valueText);
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        paddingTop={4}
        paddingBottom={0.5}
        data-testid="text-field-skeleton"
        className={overrides}
      >
        <Skeleton>
          <Typography variant="caption" component="span" noWrap>
            {primaryValue}
          </Typography>
        </Skeleton>
        <Skeleton width={fullWidth ? '100%' : undefined}>
          <Typography variant="body1" component="span" noWrap>
            {secondaryValue}
          </Typography>
        </Skeleton>
      </Box>
    </>
  );
}
